import React from 'react'
import { useNavigate } from 'react-router-dom'
import nbrApi from '../../../services/nbrApi'
import Swal from 'sweetalert2'
import TaskForm from '../../components/MangeHKT/TaskForm'

function CreateTask() {
    const navigate = useNavigate()

    // handleGoBack
    const handleGoBack = () => {
        navigate(-1)
    }
    
    // create action
    const handleForm = async (propsData) => {
        const { property, taskDescription,taskName,taskSubType, status } = propsData
        if (property) {
            try {
                const response = await nbrApi.get(`/createroomitemtask?properties_id=${property}&tt_id=${taskSubType}&item_task_name=${taskName}&item_task_description=${taskDescription}`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Room Task created successful',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        handleGoBack();
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error.message)
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Room Task Create failed',
                    showConfirmButton: false,
                    timer: 2000,
                })
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Room Task Create failed',
                showConfirmButton: false,
                timer: 2000,
            })
        }

    }

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Create Task</h4>
                        <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'><i className='fa fa-undo' /> Go Back</button>
                    </div>

                    <div className="card-body col-lg-5">
                        <TaskForm handleAction={handleForm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateTask